import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { OrganizationsMenuComponent } from './organizations-menu.component'
import { RouterModule } from '@angular/router'
import { NgScrollbarModule } from 'ngx-scrollbar'

@NgModule({
  imports: [CommonModule, RouterModule, NgScrollbarModule],
  declarations: [OrganizationsMenuComponent],
  exports: [OrganizationsMenuComponent],
  providers: [],
})
export class OrganizationsMenuModule {}
